import { UPDATE_FORM_STATUS, UPDATE_RECORD, UPDATE_LAST_RUN } from './types'

const initialState = {
    formValues: {
        calenderYearToReport: "",
        // Seeds the new T2202 Type select. Blank = no default, and it gates visibility of every
        // criteria field below it, so it must exist here or the field renders uncontrolled (305354).
        t2202Type: "",
        filerAccountNumber: "",
        schoolType: 0,
        termsInCalenderYear: [],
        reportedBy: "",
        studentAddressType: 0,
        displayFilerAccountNumber: "",
        schoolTypelabel: '',
        FlyingSchooorClub: 1,
        FlyingSchooorClubLabel:''
    },
    record: [],
    lastRunByType: {}
};

const updateT2202FormStatusReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case UPDATE_FORM_STATUS:
            return {
                ...state,
                formValues: payload
            };
        case UPDATE_RECORD:
            return {
                ...state,
                record: payload
            };
        // Keyed by type rather than overwritten, so an Amended run does not erase the fact that an
        // Original one is still staged (and vice versa) — each type keeps its own last run.
        case UPDATE_LAST_RUN:
            return {
                ...state,
                lastRunByType: { ...state.lastRunByType, [payload.t2202Type]: payload }
            };
        default:
            return state;
    }
};

export default updateT2202FormStatusReducer;
